/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Diet_BadgeInputs */

const en_portal_diet_badge = /** @type {(inputs: Portal_Diet_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calories from a photo`)
};

const pl_portal_diet_badge = /** @type {(inputs: Portal_Diet_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalorie ze zdjęcia`)
};

/**
* | output |
* | --- |
* | "Calories from a photo" |
*
* @param {Portal_Diet_BadgeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_diet_badge = /** @type {((inputs?: Portal_Diet_BadgeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Diet_BadgeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_diet_badge(inputs)
	return en_portal_diet_badge(inputs)
});